import { EGGSHELL } from "@ui/tokens/pageColors";
import type { VariantProps } from "class-variance-authority";

import { cva } from "class-variance-authority";

const markerDotVariants = cva("absolute z-20 flex h-20 w-20 items-center justify-center rounded-full", {
  variants: {
    position: {
      topLeft: "left-0 top-0 -translate-x-1/2 -translate-y-1/2",
      topRight: "right-0 top-0 -translate-y-1/2 translate-x-1/2",
      topCentered: "top-0 left-1/2 -translate-x-1/2 -translate-y-1/2",
      bottomLeft: "bottom-0 left-0 -translate-x-1/2 translate-y-1/2",
      bottomRight: "bottom-0 right-0 translate-x-1/2 translate-y-1/2",
      bottomCentered: "bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2",
    },
  },
  defaultVariants: {
    position: "topLeft",
  },
});

export const CornerMarkerDot = ({
  backgroundColor = EGGSHELL,
  position,
}: {
  backgroundColor?: string;
} & VariantProps<typeof markerDotVariants>) => {
  return (
    <div
      className={markerDotVariants({ position })}
      style={{ backgroundColor: `var(--marker-background-color, ${backgroundColor})` }}
    >
      <div className='h-2 w-2 rounded-full bg-inverse' />
    </div>
  );
};
